"use client"
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";

import { useMediaQuery } from "react-responsive";
import InlineSignupForm from "@/components/login/InlineSignupForm";

const InlineSignupModal = ({
  name,
  type,
  state,
  show,
  modalTitle,
  signupHeading,
  signupText,
  onHide
}) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });

  return (
    <Modal
      scrollable={true}
      show={show}
      size="md"
      centered
      fullscreen={isSm}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <InlineSignupForm
          name={name}
          showHeading={true}
          heading={signupHeading}
          text={signupText}
          type={type}
          state={state}
        />
      </Modal.Body>
    </Modal>
  );
};
export default InlineSignupModal;
